import styled from "styled-components";
import { FestivalCompetitionTab } from "../../../../../hooks/use-festival-tab";

export const FestivalCompetitionTabWrapper = styled.div<{
  activeTab: FestivalCompetitionTab;
}>`
  display: flex;
  width: 100%;
  position: relative;
  border-bottom: 1px solid #dedede;
  height: 41px;
  margin-bottom: 20px;

  > .background {
    position: absolute;
    top: 0;
    left: ${({ activeTab }) =>
      activeTab === FestivalCompetitionTab.EVENT
        ? "0%"
        : activeTab === FestivalCompetitionTab.POSTER
        ? "33.3%"
        : "66.6%"};
    width: 33.3%;
    height: 41px;
    z-index: 0;
    transition: left 0.5s ease;
    border-bottom: 1px solid #121212;
  }
`;

export const FestivalCompetitionTabItem = styled.div<{ isSelected: boolean }>`
  flex: 1;
  padding: 12px 0;
  font-weight: 700;
  font-size: 16px;
  text-align: center;
  color: ${(p) => (p.isSelected ? "#121212" : "#dedede")};
  transition: all 0.4s ease;
`;
